module.exports = __webpack_public_path__ + "img/boone-circle.4074b867.png";